import Vue from 'vue';
import VueRouter from 'vue-router';
import { default as naviMaker, findNode, stuff, combo, flat, debug} from "@packy-tang/navi-maker";
export { findNode, stuff,combo } from "@packy-tang/navi-maker";

import { UPDATE_NAVIGATION } from "@/stores/types"
import nodes from "@/routes/nodes.conf"
import conf from "@/configs/"

import store from '@/stores/index';

Vue.use(VueRouter);

let defaultRoute = { name: "target" };
export const menuTypes = ['iv-menu-item','iv-submenu','iv-menu-group']
export const [
  IV_MENU_ITEM,
  IV_SUBMENU,
  IV_MENU_GROUP,
] = menuTypes

const routes = stuff(naviMaker.getRoute(nodes), [], { handler:({node},{handler,stuff})=>{
  const {meta={},component,path, ...routeSetting} = (node.route||{})
  const navi = (node.navi||{})
  return {
    name: node.name,
    path: path,
    meta: {
      ...meta,
      title: meta.title || navi.title || node.title,
      navi: { ...(meta.navi||{}), ...navi },
      ...(node.stage?{stage:node.stage}:{}),
    },
    component: component,
    children: stuff(node.children, [], {handler,stuff}),
    ...routeSetting,
  }
} })

export const router = new VueRouter({
  routes,
  strict: conf.debug
});

const navi = stuff(naviMaker.getNavi(nodes), [], { handler:({node,level},{handler,stuff})=>{
  const navi = node.navi||{}
  const route = router.getRoutes().find(i=>i.name==node.name)
  const routeNode = router.resolve({ name: node.name })
  const type = ((node)=>{
    let result = 0
    node.children.filter(({navi={}}={})=>(typeof navi.shown == 'undefined'?true:navi.shown)).length > 0 && ++result
    if(typeof node.navi.menuType !== 'undefined') result = node.navi.menuType //由sitemap.js的naviRule存入
    return result
  })(node)

  return {
    name: node.name,
    level: level,
    title: navi.title || node.title,
    path: navi.path || (route?routeNode.route.path:''),
    type: menuTypes[type],
    shown: typeof navi.shown == 'undefined' ? true : navi.shown,
    detail: node.detail,
    children: stuff(node.children, [], {handler,stuff,level:level+1})
  }
} })

export function getRoute(){ //VueRouter数据结构
  return routes
}

export function getNavigations(){ //Navi数据结构
  return navi
}

export function getCrumb(route){ //Navi数据结构
  return naviMaker.getCrumb(route, navi)
}

export function getSitemap(){ //Tree数据结构
  return naviMaker.getSitemap(nodes)
}

export function getStage(){ //Tree数据结构
  const tree = stuff(nodes, [])
  const sitemap = flat(tree).filter(node=>!!node.stage)
  return combo(sitemap, tree)
}

function checkPermissionCanInPage(resources, permissions, $route){
  // 当用户存在权限时，判断是否包含当前路由的权限，不存在权限将不会跳转
  var can = true;
  if (typeof resources == 'function') {
      can = resources(permissions, $route);
  } else {
      can = Object.keys(resources).every(resource => {
          //当有数据权限时必定能进入页面，操作控制让页面里处理。
          return !!permissions[resource];
      });
  }
  return can;
}
function findPermisionsPage(router, permissions={}){
  const routes = router.getRoutes()
  const [canPage] = routes.filter(route=>Object.keys(permissions).some(per=>Object.keys(route.meta.permissions||{}).indexOf(per)>-1))
  return canPage
}

router.beforeEach(async (to, from, next) => {
  //根据路由拼凑标题头
  let pageTitle;
  //TODO:根据路由拼凑标题头
  pageTitle = to.matched
      .map((matched) => matched.meta.title || "")
      .filter((title) => !!title)
      .reverse()
      .join(" - ")

  if (to.matched.some(record => record.meta.validation)) {
      const account = store.state.account;
      // 判断是否登录逻辑
      if (!account.loggedIn || !account.user ) {
          return next({
              path: '/auth/login',
              query: { redirect: to.fullPath }
          });
      }

      defaultRoute = findPermisionsPage(router, store.state.account.authorization.permission)
      // console.log(defaultRoute)

      // 路由权限部分逻辑
      var page_permissions = {};
      to.matched.forEach(record=>{
          page_permissions = Object.assign(page_permissions, record.meta.permissions);
      });
      const role = account.user.group;
      const permissions = account.authorization ? account.authorization.permission : {};
      const parentNode = to.matched.find(record=>typeof record.meta.stage !== 'undefined')
      if(!!parentNode) store.commit(UPDATE_NAVIGATION, parentNode.meta.stage)
      // 当系统不检测路由权限时跳过
      if(conf.permissionOn.route){
        if (Object.keys(permissions).length <= 0){
            // 当用户不存在任何权限时直接登出
            return next({
                path: '/auth/login'
            });
        }

        //通过资源判断权限
        if(to.matched.some(record => record.meta.permissionOn)){
            if (!checkPermissionCanInPage(page_permissions, permissions, to)){
                console.group("权限提示")
                console.log("页面权限", Object.keys(page_permissions))
                console.log("个人权限", Object.keys(permissions))
                console.groupEnd("权限提示")
                Vue.prototype.$ivNotice.warning({
                  title: "权限提示",
                  desc: `你没有${pageTitle}页面的访问权限！`
                })
                return next(from.name=='login'?defaultRoute:false);
            }
        }
      }else{
          if (typeof to.meta.redirections != 'undefined' && to.meta.redirections.length > 1){
              const redirection = to.meta.redirections[0];
              return next({ name: redirection.name });
          }
      }
  }

  if (to.matched.length > 0) {
      const siteTitle = process.env.VUE_APP_SITE_NAME||"后台管理"
      document.title = `${pageTitle} | ${siteTitle}`
  }
  next();
});

// router.onError(function(err){
//   // console.log(err, this)
//   Vue.prototype.$ivNotice.warning({
//     title: "权限提示",
//     desc: err.message
//   })
// })


export default router;

